import React from "react";
import { useNavigate } from "react-router-dom";
import "./ClassroomTraining.css";

import classroomImg from "../assets/Classroom1.png";
import classroomImg2 from "../assets/Classroom2.png";

import {
  FaChalkboardTeacher,
  FaUsers,
  FaLaptopCode,
  FaProjectDiagram,
  FaArrowRight,
} from "react-icons/fa";

const ClassroomTraining = () => {
  const navigate = useNavigate();

  return (
    <div className="classroom-page">
      <div className="classroom-hero">
        <div className="breadcrumb">
          <span onClick={() => navigate("/")}>Home</span> /
          <span className="active"> Classroom Training</span>
        </div>
      </div>

      <div className="classroom-section">
        <div className="classroom-container">
          <div className="classroom-left">
            <img src={classroomImg} alt="training" />
          </div>

          <div className="classroom-right">
            <h2>About Classroom Training</h2>
            <p>
              AAPS Placements provides structured Classroom Training programs
              designed to build strong technical foundations with real-time
              interaction. Students get direct guidance from expert trainers,
              improving both practical and theoretical knowledge.
            </p>

            <p>
              Our training focuses on industry-level skills, live coding
              sessions, and real-world problem solving to make candidates
              job-ready.
            </p>

            <div className="points">
              <p>
                <FaArrowRight /> Face-to-face expert guidance
              </p>
              <p>
                <FaArrowRight /> Real-time doubt clarification
              </p>
              <p>
                <FaArrowRight /> Practical hands-on sessions
              </p>
              <p>
                <FaArrowRight /> Job-oriented training
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="features-section">
        <h2>Why Choose Our Training?</h2>

        <div className="features-grid">
          <div className="feature-card">
            <FaChalkboardTeacher className="icon" />
            <h3>Expert Trainers</h3>
            <p>Industry professionals guide you step by step.</p>
          </div>

          <div className="feature-card">
            <FaUsers className="icon" />
            <h3>Interactive Sessions</h3>
            <p>Engaging classroom environment for better learning.</p>
          </div>

          <div className="feature-card">
            <FaLaptopCode className="icon" />
            <h3>Hands-on Practice</h3>
            <p>Work on real-time coding exercises.</p>
          </div>

          <div className="feature-card">
            <FaProjectDiagram className="icon" />
            <h3>Live Projects</h3>
            <p>Build industry-level projects.</p>
          </div>
        </div>
      </div>

      <div className="classroom-section reverse">
        <div className="classroom-container">
          <div className="classroom-left">
            <img src={classroomImg2} alt="training" />
          </div>

          <div className="classroom-right">
            <h2>What You Will Gain</h2>

            <ul>
              <li>✔ Strong technical knowledge</li>
              <li>✔ Confidence in interviews</li>
              <li>✔ Real-time project experience</li>
              <li>✔ Placement-ready skills</li>
            </ul>

            <p className="extra-text">
              Our goal is not just training — we focus on transforming students
              into professionals with the right mindset and skillset.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClassroomTraining;
